import Link from "next/link";
import Header from "../components/shop/Header";
import Mailchimp from "../components/mailchimp/embed";
import { sanityClient } from "../lib/Sanity";
import Faq from "../components/faq";
import Head from "next/head";

export async function getStaticProps() {
  const faqs = await sanityClient.fetch(`
    *[_type == "faq" && "Deals" in faqCategory[]->title] | order(publishedAt asc) {
      title, 
      body,
      _id,
      publishedAt,
      faqCategory[] -> {
        title
      }
    }
  `);

  return {
    props: {
      faqs,
    },
    revalidate: 3600, 
  };
}



export default function Rewards({ faqs }) {

  return (
    <>
      <header>
        <Head>
          <title>Rewards | Purple Lotus</title>
          <meta
            property="og:title"
            content="Rewards | Purple Lotus"
            key="title"
          />
          <meta
            name="description"
            content="Earn loyalty rewards on every in-store, pickup, or delivery order"
          />
        </Head>

        <Header category="rewards" />
      </header>

      <main className="text pb-4">
        <div className="container">
          <div className="row-slim rewards">
            <div className="reward">
              <h2 className="pb-1">New Customer Rewards</h2>

              <div className="orders">
                <div>
                  <span className="fw-semi-bold">1<sup>st</sup> Order</span>
                  <ul>
                    <li>Free gift with purchase</li>
                    <li>25% off Delivery order <br /> <span className="fw-500">Promo code: new25</span></li>
                  </ul>
                </div>
                <div>
                  <span className="fw-semi-bold">2<sup>nd</sup> Order</span>

                  <span>1g Flower or Vape</span>
                  <span className="fs-300 italic">* In-house products only.</span>

                </div>
                <div>
                  <span className="fw-semi-bold">3<sup>rd</sup> Order</span>
                  <span>10% off your total order </span>
                </div>
                <div>
                  <span className="fw-semi-bold">4<sup>th</sup> Order+</span>
                  <span>Start earning 5% back on every purchase</span>
                </div>
              </div>
            </div>
            <div>
              <div className="reward buds-for-buds" data-type="primary">
                <h2 className="pb-1">Buds for Buds</h2>
                <p className="balance text-center">
                  Bring a friend and you both receive a choice of a free gift:
                </p>
                <div className="odd-columns">
                  <Link href="/shop?category=pre-roll&brand=Purple+Lotus">
                    Purple Lotus x Sublime preroll
                  </Link>
                  <Link href="/shop/vape?brand=Purple+Lotus">
                    Purple Lotus Vape Cartridge
                  </Link>
                  <Link href="/shop?category=flower&brand=blue+chip">
                    Blue Chip Flower (1g)
                  </Link>
                </div>
              </div>

              <div className="reward subscribe" data-type="light">
                <h2 className="pb-1">Subscriber Specials</h2>
                <Mailchimp />
              </div>
            </div>
          </div>
          <Faq
            faqs={faqs}
            title="Deal, Discounts & Rewards"
          />
        </div>
      </main>
    </>
  );
}